import { toast } from '@/hooks/use-toast';

const newMessage = (type, title, message) => {
    let variant = 'default';

    if (type === 'success') {
        variant = 'success';
    } else if (type === 'error') {
        variant = 'destructive';
    } else if (type === 'info') {
        variant = 'info';
    }

    toast({
        title: title || undefined,
        description: message,
        variant: variant,
        duration: 3000,
    });
};

const error = (message, title = 'Error') => {
    newMessage('error', title, message);
};

const success = (message, title = 'Success') => {
    newMessage('success', title, message);
};

const info = (message, title = 'Info') => {
    newMessage('info', title, message);
};

export const toastHelper = {
    newMessage,
    error,
    success,
    info,
};
